// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"Home_cardsContainer__1EVCG","link":"Home_link__3vwIa","spinnerContainer":"Home_spinnerContainer__3ncDS"};